import React from 'react';
import './progressRing.scss';
import { Popover } from 'ui-components/popover/popover';

export interface ProgressRingProps {
    value: number;
    type?: string;
    icon?: React.ReactNode;
    size?: number;
    strokeWidth?: number;
    showLabel?: boolean;
    legendDescription?: string;
};

const getProgressColor = (value: number) => {
    if (value <= 33) return 'var(--progress-low)';
    if (value <= 66) return 'var(--progress-medium)';
    return 'var(--progress-high)';
};

export const ProgressRing = ({
    value,
    type,
    icon,
    size = 50,
    strokeWidth = 4,
    showLabel = true,
    legendDescription
}: ProgressRingProps) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (value / 100) * circumference;

    const color = getProgressColor(value);

    return (
        <div
            className="xgs-progress-ring"
            style={{ width: size }}
            title={type ? `${type}: ${value}%` : `${value}%`}
        >
            <div className="xgs-progress-ring__circle">
                <svg className="xgs-progress-ring__circle__rotate" width={size} height={size}>
                    <circle
                        className="xgs-progress-ring__bg"
                        strokeWidth={strokeWidth}
                        r={radius}
                        cx={size / 2}
                        cy={size / 2}
                    />

                    <circle
                        className="xgs-progress-ring__progress"
                        strokeWidth={strokeWidth}
                        r={radius}
                        cx={size / 2}
                        cy={size / 2}
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                        style={{ stroke: color }}
                    />
                </svg>

                <div className="xgs-progress-ring__center">
                    {!!icon && <span className="xgs-progress-ring__icon">{icon}</span>}
                    {showLabel && <span className="xgs-progress-ring__value">{value}%</span>}
                </div>
            </div>

            {!!type && <div className="xgs-progress-ring__type">
                {type}
                {!!legendDescription && <Popover values={legendDescription} />}
            </div>}
        </div>
    );
};